import React from "react";
import { map, values } from "ramda";
import styles from "./styles.scss";
import { StatusComponent } from "Portal/NewPortal/Sections/Home/Cards/Tasks/View/Task";
import cx from "classnames";
import Avatar from "Portal/NewPortal/Shared/Avatar";

const CalendarDay = ({ events = [], date }) => {
  return (
    <div className={styles.event}>
      <div className={styles.eventTop}>
        <div className={styles.eventDate}>
          <div className={styles.eventDateText}>{date}</div>
          {/* <div className={styles.eventToday}>(Today)</div> */}
        </div>
        <div className={styles.eventListContainer}>
          {map(
            (item, index) => (
              <Event key={index} eventData={item} date={date} />
            ),
            events
          )}
        </div>
      </div>
    </div>
  );
  // </>
};

const EventList = ({ calendarData = {} }) => {
  return (
    <div className={styles.upcomingEventsContainer}>
      {Object.keys(calendarData).map(month => (
        <>
          {map(
            (day, index) => (
              <CalendarDay key={index} date={day.date} events={day.events} />
            ),
            values(calendarData[month])
          )}
        </>
      ))}
    </div>
  );
};

const Event = ({ eventData }) => {
  const {
    status = null,
    open_label = null,
    eventId = 123123,
    eventName = "Collidian Ort",
    description = null,
    type = null,
    time = "6:00pm - 7:00pm"
  } = eventData || {};

  return (
    <div className={styles.eventTitleContainer}>
      <div className={styles.eventTitle}>
        <div className={styles.eventTitleContent}>
          <div className={styles.eventTime}>
            <div
              className={cx(styles.eventTimeCircle, {
                [styles.taskCircle]: type === "task",
                [styles.eventCircle]: type === "event"
              })}
            />
            <div className={styles.eventTimeText}>{time}</div>
          </div>
          <div className={styles.eventTitleTextContainer}>
            <div className={styles.eventTitleText}>{description}</div>
            {type === "task" && (
              <div className={styles.eventTitleIndicator}>
                <div className={styles.eventTitleIndicatorInner}></div>
                <StatusComponent
                  className={styles.eventTitleIndicatorInner}
                  status={status}
                  open_label={open_label}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <Avatar
            id={eventId}
            name={eventName}
            square={true}
            longInitials={true}
            style={{
              width: "16px",
              height: "16px",
              minWidth: "16px",
              minHeight: "16px",
              fontSize: "8px",
              borderRadius: "4px"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EventList;
